import { Formik, FormikHelpers } from "formik";
import { useEffect, useState } from "react";
import { Button, Card, Col, Form, Row } from "react-bootstrap";
import ReactQuill from "react-quill";
import * as Yup from "yup";
import GlobalSettingsApi from "../../../api/GlobalSettingsApi";
import { QuillModules } from "../../../config/app-constants";
import { EToastvariant, IGlobalSettings, IPrivacyPolicyForm } from "../../../config/interfaces";
import { useAppDispatch } from "../../../redux/Store";
import { showToastMsg } from "../../../redux/slice/ToastMsgSlice";
import { UtilService } from "../../../services";
import { ButtonSpinner } from "../../placeholders";

// Validation Schema of Privacy and Pollicy
const privacyPolicySchema = Yup.object().shape({
  privacy_policy: Yup.string().trim().required("This field is required")
});

const PrivacyPolicy = () => {
  const dispatch = useAppDispatch();
  const [privacyPolicyData, setPrivacyPolicyData] = useState<IGlobalSettings>();

  useEffect(() => {
    getPrivacyPolicy();
  }, []);

  // Get PrivacyPolicy Value
  const getPrivacyPolicy = async () => {
    try {
      const api = GlobalSettingsApi.getInstance();
      const response = await api.getGlobalSettingByKey("PRIVACY_POLICY");
      setPrivacyPolicyData(response?.data);
    } catch (error) {
      dispatch(
        showToastMsg({
          isVisible: true,
          title: "Error",
          message: UtilService.getErrorMessage(error),
          variant: EToastvariant.Danger
        })
      );
    }
  };

  const initialPrivacyPolicyFormValues: IPrivacyPolicyForm = {
    privacy_policy: privacyPolicyData?.value || ""
  };

  // handleSubmit of Privacy and Pollicy
  const handlePrivacyPolicyFormSubmit = async (
    values: { privacy_policy: string },
    { setSubmitting }: FormikHelpers<any>
  ): Promise<void> => {
    try {
      const api = GlobalSettingsApi.getInstance();
      const _values: any = {
        value: values.privacy_policy
      };
      let _msg = `Privacy policy added successfully.`;
      if (privacyPolicyData?.uuid && privacyPolicyData) {
        await api.updateGlobalSettings(privacyPolicyData.uuid, _values);
        _msg = `Privacy policy updated successfully.`;
      } else {
        _values.key = "PRIVACY_POLICY";
        await api.createGlobalSettings(_values);
      }

      dispatch(
        showToastMsg({
          isVisible: true,
          title: "Success",
          message: _msg,
          variant: EToastvariant.Success
        })
      );
      // dispatch(fetchGlobalSettings());
    } catch (error) {
      dispatch(
        showToastMsg({
          isVisible: true,
          title: "Error",
          message: UtilService.getErrorMessage(error),
          variant: EToastvariant.Danger
        })
      );
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <>
      <Formik
        enableReinitialize={true}
        initialValues={initialPrivacyPolicyFormValues}
        validationSchema={privacyPolicySchema}
        onSubmit={handlePrivacyPolicyFormSubmit}
      >
        {({ handleSubmit, isSubmitting, handleChange, values }) => (
          <>
            <Card className="form-card tab-card">
              <Card.Body>
                <Row>
                  <Col>
                    <Form.Group className="form-group" controlId="privacy_policy">
                      <ReactQuill
                        theme="snow"
                        modules={QuillModules}
                        value={values.privacy_policy}
                        onChange={handleChange("privacy_policy")}
                        placeholder="Enter privacy policy"
                      />
                    </Form.Group>
                  </Col>
                </Row>
                <div className="form-btns-wrap">
                  <Button
                    variant="primary"
                    type="button"
                    size="lg"
                    className="btn-w-160 text-white"
                    onClick={() => handleSubmit()}
                  >
                    {!isSubmitting ? "Save" : <ButtonSpinner />}
                  </Button>
                </div>
              </Card.Body>
            </Card>
          </>
        )}
      </Formik>
    </>
  );
};

export default PrivacyPolicy;
